// extracted by mini-css-extract-plugin
export default {"boxFlex":"A22x_cIa8FNUx0dHhcBK","boxShrink":"NcEAo_KeXOMzwB4lXHIs","boxGrow":"xbO8JO2JBwf5p1ttq9Lp"};